// Theme configuration for light/dark mode
export const themes = {
  light: {
    background: '#f1f5f9',      // Fond page (légèrement plus riche)
    surface: '#ffffff',         // Cartes / surfaces élevées
    surfaceHover: '#f8fafc',
    text: '#0f172a',
    textSecondary: '#64748b',
    border: '#e2e8f0',
    accent: '#066183',
    accentHover: '#054d6b',
    accentGlow: '#0891b2',
    accentSoft: 'rgba(6, 97, 131, 0.12)',
    inputBackground: '#f8fafc',
    panelInset: '#f8fafc',
  },
  dark: {
    background: '#0f1419',
    surface: '#1a2332',
    surfaceHover: '#243044',
    text: '#f1f5f9',
    textSecondary: '#94a3b8',
    border: '#334155',
    accent: '#0891b2',
    accentHover: '#22d3ee',
    accentGlow: '#22d3ee',
    accentSoft: 'rgba(34, 211, 238, 0.14)',
    inputBackground: '#111827',
    panelInset: '#151c28',
  },
};

export const getTheme = (isDark) => isDark ? themes.dark : themes.light;